import { render, staticRenderFns } from "./OfferFeaturedProducts.vue?vue&type=template&id=66a02cb4&"
import script from "./OfferFeaturedProducts.vue?vue&type=script&lang=js&"
export * from "./OfferFeaturedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports